/** ***********
*
* <asset-history.actions.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  NG6C740 [thomas.pereira.external@airbus.com]
*  ng6c740 [thomas.pereira.external@airbus.com]
*
* All rights reserved.
**************/

import { createAction, props } from '@ngrx/store';
import { Event } from 'src/app/models/event';
import { Zone } from 'src/app/models/zone';

export const loadAssetHistory = createAction('[asset] Load Asset History');
export const successAssetHistory = createAction('[asset] Success Assets History', props<{ payload: Event[], zones: Zone[]  }>());
export const errorAssetHistory = createAction('[asset] Error Assets History');
